<article>
  <a class="favorite-row" [routerLink]="['/gateway', favoriteSite().gatewayId]">
    <app-gateway-icon [gatewayId]="favoriteSite().gatewayId" [nbBoxes]="favoriteSite().nbSetupGateways" />
    <div class="favorite-info">
      <div class="client-name">
        {{ favoriteSite().clientName }}
      </div>
      @if (favoriteSite().alert; as alert) {
        <div class="alert">
          <app-alert-severity [severity]="alert.severity" [size]="16" />
          <span class="alert-date">{{ alert.date | format: { type: 'shortDate' } }}</span>
        </div>
      }
    </div>
    @if (editMode()) {
      <button
        type="button"
        class="delete-button"
        [attr.aria-label]="'DELETE' | translate"
        (click)="onDeleteFavorite($event)"
      >
        <app-icon path="assets/img/close.svg" [size]="16" />
      </button>
    }
  </a>
</article>
